<div id="otp-input" class="otp-field" data-qa="genesys-call-log_otp-input">
  <ng-container *ngFor="let _ of referencePositions; let i = index">
    <div class="otp-input-container">
      <span class="position-indicator">
        {{ _.position + 1 }}
        <span class="ordinal-suffix">{{
          _.position + 1 | formatNumberToOrdinal
        }}</span></span
      >
      <input
        [attr.data-index]="i"
        [attr.data-qa]="'genesys-call-log_otp-input_input_' + _.position"
        [ngClass]="isInputInvalid(i, _.position)"
        type="text"
        maxlength="1"
        autocomplete="no"
        [disabled]="isDisabled"
        (input)="onInputChange(i, $event)"
      />
    </div>
  </ng-container>
</div>

<div *ngIf="isDisabled" class="otp-input-attempts-error" data-qa="genesys-call-log_otp-input_attempts-error">
  {{
    "errors.max_attempts"
      | translate
        : {
            attempts: maxAttempts | translate
          }
  }}
</div>

<div *ngIf="!otpValue" class="otp-input-data-error" data-qa="genesys-call-log_otp-input_data-error">
  {{ "errors.NoInputsSpecified" | translate }}
</div>
